// @flow

import * as React from 'react';
import { Tabs, Spin } from 'antd';
import { MenuOutlined, CloseOutlined } from '@ant-design/icons';
import { isAdmin, isAdvanced, isPremium } from 'Common';
import Screen from '../../Components/Screen';

import Initializing from './Components/Initializing';
import Breadcrumbs from './Components/Breadcrumbs';
import Header from './Components/Header';
import Sidebar from './Components/Sidebar';
import FileManager from './Components/FileManager';
import Estimates from './Components/Estimates';
import Orders from './Components/Orders'
import Procurement from './Components/Procurement'
import TargetCosts from './Components/TargetCosts'
import Valuations from './Components/Valuations';
import Invoices from './Components/Invoices';
import RetentionPayments from './Components/RetentionPayments';
import RamsRecords from './Components/RamsRecords';
import Activity from './Components/Activity';
import Summary from './Components/Summary';

import ProjectModal from '../../Modals/Project';
import EstimateModal from '../../Modals/Estimate';
import OrderModal from '../../Modals/Order';
import ValuationDateModal from '../../Modals/ValuationDate';
import ValuationModal from '../../Modals/Valuation';
import UploadModal from '../../Modals/Upload';
import DirectoryModal from '../../Modals/Directory';
import JobSheetModal from '../../Modals/JobSheet';
import ProjectCompleteModal from '../../Modals/ProjectComplete';
import MoveFilesModal from '../../Modals/MoveFiles';
import ClientSiteModal from '../../Modals/ClientSite';
import ClientContactModal from '../../Modals/ClientContact';
import ViewEmailModal from '../../Modals/ViewEmail';
import RetentionPaymentModal from '../../Modals/RetentionPayment'
import RamsRecordModal from '../../Modals/RamsRecord'
import FileViewerModal from '../../Modals/FileViewer'
import EmailProjectInformationModal from '../../Modals/EmailProjectInformation'
import EmailModal from '../../Modals/Email'
import TBTProjectReportsModal from '../../Modals/TBTProjectReports'
import RamsProjectReportsModal from '../../Modals/RamsProjectReports'
import Emails from '../../Screens/Emails'
import SubcontractorTimesheets from './Components/SubcontractorTimesheets'
import SubcontractorOrders from './Components/SubcontractorOrders'
import Planner from '../../Screens/Planner'
import Feedback from './Components/Feedback'

import type { ScreenProps } from './types';

export default class extends React.PureComponent<ScreenProps> {

  constructor(props) {
    super(props);
    this.tbtReportsModalRef = React.createRef();
    this.ramsReportsModalRef = React.createRef();
    this.sidebarRef = React.createRef();
    this.state = {
      sidebarOpen: false,
    };
  }

  toggleSidebar = () => {
    this.setState(prevState => ({ sidebarOpen: !prevState.sidebarOpen }));
  };

  componentWillMount = () => this.props.componentWillMount(this.props);

  componentDidUpdate = () => this.props.componentDidUpdate(this.props);

  componentWillUnmount = () => this.props.componentWillUnmount();

  handleTBTReportsClick = () => {
    if (this.tbtReportsModalRef.current && this.props.project) {
      this.tbtReportsModalRef.current.show(this.props.project);
    }
  };

  handleRamsReportsClick = () => {
    if (this.ramsReportsModalRef.current && this.props.project) {
      this.ramsReportsModalRef.current.show(this.props.project);
    }
  };

  render () {

    const showAdvancedFeatures = isAdvanced() || isPremium();

    const {

      project,
      fetching,
      rootDirectories,
      currentDirectoryPath,
      selectedItemPath,
      checkedItemPaths,
      listItems,
      activeTab,
      selectedEmailId,

      estimateStatuses,
      estimateTenderStatuses,
      estimateLatestActions,
      users,

      showProjectModal,
      showEstimateModal,
      showOrderModal,
      showValuationModal,
      showUploadModal,
      showDirectoryModal,
      showJobSheetModal,
      showClientSiteModal,
      showClientContactModal,
      showEmailModal,
      showViewEmailModal,

      fetchingDirectory,
      fetchingRootDirectories,

      didUpdateProject,
      didDeleteProject,
      didCreateEstimate,
      didCreateOrder,
      didCreateValuation,
      didUpdateClientSite,
      didUpdateClientContact,

      onClickActionMenuItem,
      onCloseProjectModal,
      onCloseEstimateModal,
      onCloseOrderModal,
      onCloseValuationModal,
      onCloseClientSiteModal,
      onCloseClientContactModal,
      onCloseViewEmailModal,
      showProjectCompleteModal,
      showMoveFilesModal,

      onSelectRootDirectory,
      onSelectItem,
      onDoubleClickItem,
      onToggleItemCheckbox,

      onClickNewEstimate,
      onClickNewOrder,
      onClickNewValuation,
      onChangeEstimateField,
      onChangeActiveTab,
      onChangeSearch,

      onToggleSelectAll,

      searchTerm,
      filemode,
      selectedItemType,

      onClickGrid,
      onClickList,
      onClickUpload,
      onClickDownload,
      onCloseUploadModal,
      onClickNewFolder,
      onCloseDirectoryModal,
      onClickDelete,
      onClickEdit,
      didCreateDirectory,
      didRename,
      didUpload,
      onClickFileContextMenuItem,
      onClickPathBreadcrumb,
      onChangeNotes,
      didCreateJobSheetModal,
      onCloseJobSheetModal,
      directoryActionType,
      onCloseProjectCompleteModal,
      onDragEnter,
      onClickMove,
      onCloseMoveFilesModal,
      didMoveFiles,
      onClickViewEmail,

      selectedRetentionPaymentId,
      showRetentionPaymentModal,
      onCloseRetentionPaymentModal,
      didUpdateRetentionPayment,

      ramsRecordModal,
      onCloseRamsRecordModal,

      didSendEmail,
      onCloseEmailModal,

      valuationDateModal,
      onClickNewValuationDate,
      onCloseValuationDateModal,

      fileViewerModal,
      onCloseFileViewerModal,

      onDragDropItem,

      feedback,
      onClickRequestFeedback,
      onClickDownloadFeedback,

    } = this.props;

    if (!project) return <Initializing />

    // Wait for full project data to load before rendering
    if (!project.action_statuses || !project.client_site || !project.client_site.client) {
      return <Initializing />
    }

    return (

      <Screen className="project-view-screen" style={{ marginRight: 280, paddingRight: 30 }}>

        <style>{`
          @media (max-width: 768px) {
            .project-view-screen {
              margin-right: 0 !important;
              padding-right: 15px !important;
            }
          }
        `}</style>

        <Breadcrumbs
          project={project}
          mobileToggle={
            <button
              onClick={this.toggleSidebar}
              style={{
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                padding: '4px 8px',
                fontSize: '20px',
                color: '#1890ff',
                display: 'none',
              }}
              className="mobile-sidebar-toggle-btn"
              aria-label="Toggle sidebar"
            >
              {this.state.sidebarOpen ? <CloseOutlined /> : <MenuOutlined />}
            </button>
          }
        />

        <style>{`
          @media (max-width: 768px) {
            .mobile-sidebar-toggle-btn {
              display: inline-block !important;
            }
          }
        `}</style>

        <Header
          project={project}
          onClickActionMenuItem={(key) => {
            if (key === 'TBT_PDF_LIST') {
              this.handleTBTReportsClick();
            } else if (key === 'RAMS_REPORTS') {
              this.handleRamsReportsClick();
            } else {
              onClickActionMenuItem(key);
            }
          }}
          onChangeNotes={onChangeNotes}
        />

        <style>{`
          @media (max-width: 768px) {
            .ant-tabs-nav-operations {
              display: flex !important;
            }
            .ant-tabs-nav-more {
              display: block !important;
            }
          }
        `}</style>

        <Tabs
          activeKey={activeTab}
          defaultActiveKey="summary"
          animated={false}
          onChange={onChangeActiveTab}
          type="card"
          tabBarGutter={8}
        >

          <Tabs.TabPane tab="Summary" key="summary">

            {activeTab === 'summary' && (
              <Summary
                project={project}
              />
            )}

          </Tabs.TabPane>

          {showAdvancedFeatures && (
            <Tabs.TabPane tab="Target Costs" key="target_costs">

              {activeTab === 'target_costs' && (
                <TargetCosts
                  project={project}
                />
              )}

            </Tabs.TabPane>
          )}

          <Tabs.TabPane tab="Files" key="files">

            <Spin spinning={fetchingRootDirectories || fetchingDirectory}>

              <FileManager
                rootDirectories={rootDirectories}
                currentDirectoryPath={currentDirectoryPath}
                selectedItemType={selectedItemType}
                selectedItemPath={selectedItemPath}
                checkedItemPaths={checkedItemPaths}
                listItems={listItems}
                onSelectRootDirectory={onSelectRootDirectory}
                onSelectItem={onSelectItem}
                onDoubleClickItem={onDoubleClickItem}
                onToggleItemCheckbox={onToggleItemCheckbox}
                onToggleSelectAll={onToggleSelectAll}
                filemode={filemode}
                onClickGrid={onClickGrid}
                onClickList={onClickList}
                onClickUpload={onClickUpload}
                onClickDownload={onClickDownload}
                onClickNewFolder={onClickNewFolder}
                onClickDelete={onClickDelete}
                onClickEdit={onClickEdit}
                onClickFileContextMenuItem={onClickFileContextMenuItem}
                onClickPathBreadcrumb={onClickPathBreadcrumb}
                project={project}
                onDragEnter={onDragEnter}
                onClickMove={onClickMove}
                onDragDropItem={onDragDropItem}
              />

            </Spin>

          </Tabs.TabPane>

          <Tabs.TabPane tab="Estimates" key="estimates">

            <Estimates
              project={project}
              fetching={fetching}
              estimateStatuses={estimateStatuses}
              estimateTenderStatuses={estimateTenderStatuses}
              estimateLatestActions={estimateLatestActions}
              users={users}
              onChangeEstimateField={onChangeEstimateField}
              onClickNewEstimate={onClickNewEstimate}
              searchTerm={searchTerm}
              onChangeSearch={onChangeSearch}
            />

          </Tabs.TabPane>

          <Tabs.TabPane tab="Orders" key="orders">

            <Orders
              project={project}
              fetching={fetching}
              onClickNewOrder={onClickNewOrder}
              searchTerm={searchTerm}
              onChangeSearch={onChangeSearch}
            />

          </Tabs.TabPane>

          <Tabs.TabPane tab="Procurement" key="procurement">

            <Procurement
              project={project}
              fetching={fetching}
              searchTerm={searchTerm}
              onChangeSearch={onChangeSearch}
            />

          </Tabs.TabPane>

          <Tabs.TabPane tab="Valuations" key="valuations">

            <Valuations
              project={project}
              fetching={fetching}
              onClickNewValuation={onClickNewValuation}
              onClickNewValuationDate={onClickNewValuationDate}
              searchTerm={searchTerm}
              onChangeSearch={onChangeSearch}
            />

          </Tabs.TabPane>

          <Tabs.TabPane tab="Invoices" key="invoices">

            <Invoices
              project={project}
              searchTerm={searchTerm}
              onChangeSearch={onChangeSearch}
            />

          </Tabs.TabPane>

          {showAdvancedFeatures && (
            <Tabs.TabPane tab="Retentions" key="retention_payments">

              <RetentionPayments
                project={project}
                searchTerm={searchTerm}
                onChangeSearch={onChangeSearch}
              />

            </Tabs.TabPane>
          )}

          {showAdvancedFeatures && (
            <Tabs.TabPane tab="RAMS" key="rams_records">

              {activeTab === 'rams_records' && (
                <RamsRecords
                  project={project}
                  fetching={fetching}
                />
              )}

            </Tabs.TabPane>
          )}

          {showAdvancedFeatures && (
            <Tabs.TabPane tab="Timesheets" key="subcontractor_timesheets">

              {activeTab === 'subcontractor_timesheets' && (
                <SubcontractorTimesheets
                  projectId={project.id}
                />
              )}

            </Tabs.TabPane>
          )}

          {showAdvancedFeatures && (
            <Tabs.TabPane tab="Sub Orders" key="subcontractor_orders">

              {activeTab === 'subcontractor_orders' && (
                <SubcontractorOrders
                  projectId={project.id}
                />
              )}

            </Tabs.TabPane>
          )}

          {showAdvancedFeatures && (
            <Tabs.TabPane tab="Planner" key="planner">

              {activeTab === 'planner' && (
                <Planner
                  componentView={true}
                  additionalFilter={{project_id: project.id}}
                />
              )}

            </Tabs.TabPane>
          )}

          {isAdmin() && showAdvancedFeatures && (


            <Tabs.TabPane tab="Activity" key="activity">

              <Activity
                project={project}
                onClickViewEmail={onClickViewEmail}
              />

            </Tabs.TabPane>

          )}

            {isAdmin() && showAdvancedFeatures && (

                <Tabs.TabPane tab="Emails" key="emails">
                    <Emails
                        componentView="1"
                        additionalFilter={{project_id: project.id}}
                    />
                </Tabs.TabPane>

            )}

            <Tabs.TabPane tab="Feedback" key="feedback">
              {activeTab === 'feedback' && (
                <Feedback
                  project={project}
                  feedback={feedback}
                  onClickRequestFeedback={onClickRequestFeedback}
                  onClickDownloadFeedback={onClickDownloadFeedback}
                />
              )}
            </Tabs.TabPane>

        </Tabs>

        {showProjectModal && (
          <ProjectModal
            project={project}
            onClose={onCloseProjectModal}
            didUpdate={didUpdateProject}
            didDelete={didDeleteProject}
          />
        )}

        {showEstimateModal && (
          <EstimateModal
            projectId={project.id}
            onClose={onCloseEstimateModal}
            didCreate={didCreateEstimate}
          />
        )}

        {showOrderModal && (
          <OrderModal
            projectId={project.id}
            onClose={onCloseOrderModal}
            didCreate={didCreateOrder}
          />
        )}

        {showValuationModal && (
          <ValuationModal
            projectId={project.id}
            onClose={onCloseValuationModal}
            didCreate={didCreateValuation}
          />
        )}

        {valuationDateModal.show && (
          <ValuationDateModal
            {...valuationDateModal}
            project={project}
            onClose={onCloseValuationDateModal}
          />
        )}

        {showUploadModal && (
          <UploadModal
            projectId={project.id}
            currentDirectoryPath={currentDirectoryPath}
            onClose={onCloseUploadModal}
            didUpload={didUpload}
          />
        )}

        {showDirectoryModal && (

          <DirectoryModal
            projectId={project.id}
            currentDirectoryPath={currentDirectoryPath}
            selectedItemPath={selectedItemPath}
            selectedItemType={selectedItemType} // directory or file
            directoryActionType={directoryActionType} // new or edit
            onClose={onCloseDirectoryModal}
            didCreate={didCreateDirectory}
            didRename={didRename}
          />

        )}

        {showJobSheetModal && (
          <JobSheetModal
            projectId={project.id}
            project={project}
            onClose={onCloseJobSheetModal}
            didCreate={didCreateJobSheetModal}
          />
        )}

        {showProjectCompleteModal && (
          <ProjectCompleteModal
            projectId={project.id}
            onClose={onCloseProjectCompleteModal}
            didComplete={didUpdateProject}
          />
        )}

        {showMoveFilesModal && (
          <MoveFilesModal
            selectedFiles={[]}
            onClose={onCloseMoveFilesModal}
            didMove={didMoveFiles}
          />
        )}

        {showClientSiteModal && (
          <ClientSiteModal
            onClose={onCloseClientSiteModal}
            didUpdate={didUpdateClientSite}
            clientSite={project.client_site}
          />
        )}

        {showClientContactModal && (
          <ClientContactModal
            onClose={onCloseClientContactModal}
            didUpdate={didUpdateClientContact}
            clientContact={project.client_contact}
          />
        )}

        {showViewEmailModal && (
          <ViewEmailModal
            onClose={onCloseViewEmailModal}
            emailId={selectedEmailId}
          />
        )}

        {showRetentionPaymentModal && (
          <RetentionPaymentModal
            id={selectedRetentionPaymentId}
            onClose={onCloseRetentionPaymentModal}
            didUpdate={didUpdateRetentionPayment}
          />
        )}

        {ramsRecordModal.show && (
          <RamsRecordModal
            onClose={onCloseRamsRecordModal}
            projectId={project.id}
            project={project}
            ramsRecordId={ramsRecordModal.ramsRecordId}
          />
        )}

        {showEmailModal && (
          <EmailProjectInformationModal
            project={project}
            onClose={onCloseEmailModal}
            didSend={didSendEmail}
          />
        )}

        <TBTProjectReportsModal ref={this.tbtReportsModalRef} />

        <RamsProjectReportsModal ref={this.ramsReportsModalRef} />

        {fileViewerModal.show && (
          <FileViewerModal
            filePath={fileViewerModal.filePath}
            fileName={fileViewerModal.fileName}
            onClose={onCloseFileViewerModal}
          />
        )}

        <Sidebar
          ref={this.sidebarRef}
          mobileOpen={this.state.sidebarOpen}
          onMobileToggle={this.toggleSidebar}
        />

      </Screen>

    )
  }
}
